let httpAgent;
let httpsAgent;

const agentParams = {
  keepAlive: true,
  keepAliveMsecs: 40000,
  maxSockets: 100,
  maxFreeSockets: 10,
};

export const getHttpAgent = () => {
  if (!httpAgent) {
    const http = require("http");
    httpAgent = new http.Agent(agentParams);
  }

  return httpAgent;
};

export const getHttpsAgent = () => {
  if (!httpsAgent) {
    const https = require("https");
    httpsAgent = new https.Agent(agentParams);
  }

  return httpsAgent;
};
